<mat-form-field class="w-100">
	<mat-select
		placeholder="Division"
		disableOptionCentering="true"
		[compareWith]="idComparer"
		[formControl]="division"
		(selectionChange)="optionSelected.emit($event.value)"
	>
		<mat-option [value]="null">
			None
		</mat-option>
		<mat-option *ngFor="let division of divisions" [value]="division">
			{{ displayName(division) }}
		</mat-option>
	</mat-select>
</mat-form-field>
